const th = {
    organization:"องค์กร",
    year:"ปี",
    months:"เดือน",
    days:"วัน",
    assessment:"ประเมิน",
    assessments:"แบบประเมินตนเอง",
    self:"ตนเอง",
    subordinate:"ผู้ใต้บังคับบัญชา",

    staffID:"รหัส พนักงาน",
    department:"หน่วยงาน",
    status:"สถานะ",

    fullname:" ชื่อ-นามสกุล",
    position:"ตำแหน่ง",
    remark:"หมายเหตุ ",
    startDate:"วันที่เริ่มงาน",
    yearsOfService:"อายุงาน",
    staffTypes:"ประเภทบุคลากร",
    competencyLevel:"ระดับ",

    reportStatus:"สถานะการตอบแบบประเมินรายหน่วยงาน",
    reportCc:"สรุปผลประเมินแยกราย Core Competency",
    reportCompetency:"สรุปผลประเมินแยกรายหน่วยงาน",


    save:"บันทึก",
    send:"ส่งข้อมูล",
    unsend:"ยกเลิกการส่ง",
    reject:"ตีกลับข้อมูล"



}
export default th
